import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
  MARKETPLACE_CONFLICT as mktConflict,
  MARKETPLACE_CONFLICT_CLEAR as mktConflictClear,
} from '../../actions/signals/delete';

const initialState = {
    response: null,
    isLoading: false,
    error: false,
    // Set when the BE returns 409 because the signal is published
    // with active subscribers. The container reads this to open
    // the cascade-confirm dialog.
    marketplaceConflict: null,
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case res:
      return {
        ...state,
        isLoading: false,
        response: action.payload
      };
    case fail:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case clr:
      return {
        ...state,
        response: null,
        isLoading: false,
        error: null,
        marketplaceConflict: null,
      };
    case mktConflict:
      return {
        ...state,
        marketplaceConflict: action.payload,
      };
    case mktConflictClear:
      return {
        ...state,
        marketplaceConflict: null,
      };
    default:
      return state;
  }
};
